/**
 * Public SSM API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0-private
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { CommandHandlerResponse } from '../model/commandHandlerResponse';
import { VPError } from '../model/vPError';
import { VehicleValuationServiceMaintenanceCreateSyncJobBody } from '../model/vehicleValuationServiceMaintenanceCreateSyncJobBody';
import { VehicleValuationServiceMaintenanceCreateSyncJobBody1 } from '../model/vehicleValuationServiceMaintenanceCreateSyncJobBody1';
import { VehicleValuationServiceMaintenanceCreateSyncJobBody2 } from '../model/vehicleValuationServiceMaintenanceCreateSyncJobBody2';
import { VehicleValuationServiceMaintenanceCreateSyncJobBody3 } from '../model/vehicleValuationServiceMaintenanceCreateSyncJobBody3';
import { VehicleValuationServiceMaintenanceResetBranchConfigurationBody } from '../model/vehicleValuationServiceMaintenanceResetBranchConfigurationBody';
import { VehicleValuationServiceMaintenanceResetBranchConfigurationBody1 } from '../model/vehicleValuationServiceMaintenanceResetBranchConfigurationBody1';
import { VehicleValuationServiceMaintenanceResetBranchConfigurationBody2 } from '../model/vehicleValuationServiceMaintenanceResetBranchConfigurationBody2';
import { VehicleValuationServiceMaintenanceResetBranchConfigurationBody3 } from '../model/vehicleValuationServiceMaintenanceResetBranchConfigurationBody3';
import { VehicleValuationServiceMaintenanceResetBusinessConfigurationBody } from '../model/vehicleValuationServiceMaintenanceResetBusinessConfigurationBody';
import { VehicleValuationServiceMaintenanceResetBusinessConfigurationBody1 } from '../model/vehicleValuationServiceMaintenanceResetBusinessConfigurationBody1';
import { VehicleValuationServiceMaintenanceResetBusinessConfigurationBody2 } from '../model/vehicleValuationServiceMaintenanceResetBusinessConfigurationBody2';
import { VehicleValuationServiceMaintenanceResetBusinessConfigurationBody3 } from '../model/vehicleValuationServiceMaintenanceResetBusinessConfigurationBody3';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class VehicleValuationServiceMaintenanceService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Lazy check AmsAction:POST/api/VehicleValuationServiceMaintenance/CreateSyncJob AmsResource:maintenance/country/{country} 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createSyncJob(body?: VehicleValuationServiceMaintenanceCreateSyncJobBody, observe?: 'body', reportProgress?: boolean): Observable<CommandHandlerResponse>;
    public createSyncJob(body?: VehicleValuationServiceMaintenanceCreateSyncJobBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandHandlerResponse>>;
    public createSyncJob(body?: VehicleValuationServiceMaintenanceCreateSyncJobBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandHandlerResponse>>;
    public createSyncJob(body?: VehicleValuationServiceMaintenanceCreateSyncJobBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CommandHandlerResponse>(`${this.basePath}/api/VehicleValuationServiceMaintenance/CreateSyncJob`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Hard deletes the Case and associated resources
     * AmsAction:DELETE/api/VehicleValuationServiceMaintenance/case/{id} AmsAction:CanHardDelete AmsResource:maintenance/case/{id} 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public hardDeleteCase(id: string, observe?: 'body', reportProgress?: boolean): Observable<CommandHandlerResponse>;
    public hardDeleteCase(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandHandlerResponse>>;
    public hardDeleteCase(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandHandlerResponse>>;
    public hardDeleteCase(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling hardDeleteCase.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<CommandHandlerResponse>(`${this.basePath}/api/VehicleValuationServiceMaintenance/case/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Resets the Branch and associated resources as if the branch had just been created  It will hard delete existing configuration, etc.
     * AmsAction:PUT/api/VehicleValuationServiceMaintenance/ResetBranchConfiguration AmsAction:CanHardDelete AmsResource:maintenance/branch/{command.AggregateRootId} 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resetBranchConfiguration(body?: VehicleValuationServiceMaintenanceResetBranchConfigurationBody, observe?: 'body', reportProgress?: boolean): Observable<CommandHandlerResponse>;
    public resetBranchConfiguration(body?: VehicleValuationServiceMaintenanceResetBranchConfigurationBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandHandlerResponse>>;
    public resetBranchConfiguration(body?: VehicleValuationServiceMaintenanceResetBranchConfigurationBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandHandlerResponse>>;
    public resetBranchConfiguration(body?: VehicleValuationServiceMaintenanceResetBranchConfigurationBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<CommandHandlerResponse>(`${this.basePath}/api/VehicleValuationServiceMaintenance/ResetBranchConfiguration`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Resets the Business and associated resources as if the business had just been created  It will hard delete existing configuration, templates, etc.
     * AmsAction:PUT/api/VehicleValuationServiceMaintenance/ResetBusinessConfiguration AmsAction:CanHardDelete AmsResource:maintenance/business/{command.AggregateRootId} 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resetBusinessConfiguration(body?: VehicleValuationServiceMaintenanceResetBusinessConfigurationBody, observe?: 'body', reportProgress?: boolean): Observable<CommandHandlerResponse>;
    public resetBusinessConfiguration(body?: VehicleValuationServiceMaintenanceResetBusinessConfigurationBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandHandlerResponse>>;
    public resetBusinessConfiguration(body?: VehicleValuationServiceMaintenanceResetBusinessConfigurationBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandHandlerResponse>>;
    public resetBusinessConfiguration(body?: VehicleValuationServiceMaintenanceResetBusinessConfigurationBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<CommandHandlerResponse>(`${this.basePath}/api/VehicleValuationServiceMaintenance/ResetBusinessConfiguration`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Synchronizes current SSM stock with Service Dealer by sending Update event for each Case in due in stock or stock status
     * Lazy check AmsAction:PUT/api/VehicleValuationServiceMaintenance/SynchronizeStockWithServiceDealer/{countryCode} AmsResource:maintenance/country/{countryCode} 
     * @param countryCode 
     * @param synchronizeSinceDate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public synchronizeStockWithServiceDealer(countryCode: string, synchronizeSinceDate?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public synchronizeStockWithServiceDealer(countryCode: string, synchronizeSinceDate?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public synchronizeStockWithServiceDealer(countryCode: string, synchronizeSinceDate?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public synchronizeStockWithServiceDealer(countryCode: string, synchronizeSinceDate?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (countryCode === null || countryCode === undefined) {
            throw new Error('Required parameter countryCode was null or undefined when calling synchronizeStockWithServiceDealer.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (synchronizeSinceDate !== undefined && synchronizeSinceDate !== null) {
          queryParameters = queryParameters.set('synchronizeSinceDate', <any>synchronizeSinceDate);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<string>(`${this.basePath}/api/VehicleValuationServiceMaintenance/SynchronizeStockWithServiceDealer/${encodeURIComponent(String(countryCode))}`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
